import {ApiUrlService} from './../services/apiUrl/api-url.service';
import {HttpService} from './../services/http/http.service';
import {HttpClient} from '@angular/common/http';
import {TranslateLoader} from '@ngx-translate/core';
import {Observable, catchError, delay, forkJoin, map, of, tap} from 'rxjs';
import {environment} from '../../environments/environment';
import {Endpoints} from '../enums/endpoints.enum';

export type RecursiveMapping = {
  [key: string]: string | number | RecursiveMapping;
};

export class CustomTranslationLoader extends TranslateLoader {
  constructor(
    protected http: HttpClient,
    protected httpService: HttpService,
    protected apiUrlService: ApiUrlService,
  ) {
    super();
  }

  override getTranslation(lang: string): Observable<RecursiveMapping> {
    const url = this.apiUrlService.getUrl(Endpoints.AEM_RESOURCE);
    return forkJoin([
      this.http.get<RecursiveMapping>(`${url}?type=json&filename=${environment.aemContent}`).pipe(
        catchError((e) => {
          console.warn('AEM json not found');
          return of({});
        }),
      ),
      this.http.get<RecursiveMapping>(environment.defaultContent),
    ]).pipe(map(([aemContent, defaultContent]) => this.mergeContent(defaultContent, aemContent)));
  }
  mergeContent(defaultContent: RecursiveMapping, aemContent: RecursiveMapping): RecursiveMapping {
    const dp = this.deepMerge(defaultContent, aemContent);
    return dp;
  }

  deepMerge(target: RecursiveMapping, source: RecursiveMapping): RecursiveMapping {
    const merged = {...target, ...source};
    for (const key in target) {
      if (typeof target[key] === 'object' && typeof source[key] === 'object') {
        const t2 = target[key] as RecursiveMapping;
        const s2 = source[key] as RecursiveMapping;
        merged[key] = this.deepMerge(t2, s2);
      }
    }
    return merged;
  }
}
